import { createSelector } from 'reselect'

import { isObject } from 'shared/helpers/obj_helpers'
import { NEW_CAMPAIGN_ID } from 'redux/modules/campaign'

const getCampaigns = state => state.campaign

const getCampaignFromProps = (state, { campaignId }) => {
  return state.campaign[campaignId]
}
const getCampaignFromLastCreationId = state =>
  state.campaign[state.campaign.last_creation_id]

export const getLastCreatedCampaignSelector = createSelector(
  getCampaignFromLastCreationId,
  campaign => campaign
)

export const getCampaignSelector = createSelector(
  getCampaignFromProps,
  campaign => campaign
)

export const getNewCampaignSelector = createSelector(
  getCampaigns,
  campaigns => {
    return campaigns[NEW_CAMPAIGN_ID]
  }
)

function isValidCampaign(campaign) {
  if (!isObject(campaign)) {
    return false
  }

  if (campaign.deleted || campaign.id === NEW_CAMPAIGN_ID) {
    return false
  }

  return true
}

export function getCrowdfundingEntryBanner(state) {
  return state.flags && state.flags.allow_crowdfunding_entry_banner
}

export const allCampaignsSelector = createSelector(getCampaigns, campaigns => {
  let allCampaigns = Object.values(campaigns).filter(isValidCampaign)

  // campaign2 is before campaign1 so that it will be sorted in descending order
  allCampaigns.sort(
    (campaign1, campaign2) =>
      new Date(campaign2.start_date).valueOf() -
      new Date(campaign1.start_date).valueOf()
  )
  return allCampaigns
})
